import { create } from "zustand";
import { useDeleteAccountModalStore } from "./delete-account-modal-store";
import { useEditColorCollectionsStore } from "./edit-color-collections-store";
import { useMySavedColorsModalStore } from "./my-saved-colors-modal-store";
import { useMyStyleModalStore } from "./my-style-modal-store";
import { useProfileImageModalStore } from "./profile-image-modal-store";
import { useAddSavedColorsToCollectionModalStore } from "./add-saved-colors-to-collection-modal-store";
import { useInviteFriendModalStore } from "./invite-friend-modal-store";

export const useAddToColorCollectionModalStore = create((set) => ({
  isModalOpen: false,
  addToCollectionUrl: null,
  openModal: (url) => {
    useDeleteAccountModalStore.getState().closeModal();
    useEditColorCollectionsStore.getState().closeModal();
    useMySavedColorsModalStore.getState().closeModal();
    useMyStyleModalStore.getState().closeModal();
    useProfileImageModalStore.getState().closeModal();
    useAddSavedColorsToCollectionModalStore.getState().closeModal();
    useInviteFriendModalStore.getState().closeModal();

    set({ isModalOpen: true, addToCollectionUrl: url });
  },
  closeModal: () => set({ isModalOpen: false, addToCollectionUrl: null }),
  updateIsModalOpen: (isModalOpen) => set({ isModalOpen }),
}));
